import { PaymentPlanCodes, SubscriptionTypes } from '../../restaurant/enums';
import { FreePlanSubscriptionStates } from '../../recurly/constants';
import { LocationRecurly } from '../../restaurant/models';

export function isOnFreePlan(user: FreePlanUser): boolean {
  return user.account.subscriptionType === SubscriptionTypes.recurly
    && (user.location.recurly?.planCode === PaymentPlanCodes.Free
      || FreePlanSubscriptionStates.includes(user.location.recurly?.subscription_state));
}

interface FreePlanUser {
  account?: {
    subscriptionType: SubscriptionTypes;
  };
  location?: {
    recurly: LocationRecurly;
  };
}
